$(document).ready(function(){
    $('body').on('click', '.locked-overlay[locked-url]', function(ev){
        var $el = $(ev.currentTarget);
        var postUrl = $el.attr('locked-url');

        if(!$('body').hasClass('logged-in')){
            sessionStorage.setItem('cca_redirect_locked', postUrl);
        }
    });

    if($('body').hasClass('logged-in')){
        var url = sessionStorage.getItem('cca_redirect_locked');
        if(url && url.length > 0){
            sessionStorage.setItem('cca_redirect_locked', '');
            window.location.href = url;
        }
    }

    $('body').on('click', '.close-button', function () {
        sessionStorage.setItem('cca_redirect_locked', '');
    });
    
});